module.exports = __webpack_public_path__ + "assets/99c48dde0f998d3606e33fb39c70964c.svg";